var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "head" }, [
      _c("img", {
        staticClass: "imgs",
        attrs: { src: _vm.fourLogo, alt: "", srcset: "" }
      }),
      _vm._v(" "),
      _c("h2", { staticClass: "title" }, [_vm._v("生猪大数据中心")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "headBox" },
        _vm._l(_vm.titleHead, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "headItem",
              on: {
                click: function($event) {
                  return _vm.selectHead(item, index)
                }
              }
            },
            [
              _c("div", [
                _vm._v(
                  "\n                    " +
                    _vm._s(item.label) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              item.active ? _c("div", { staticClass: "active" }) : _vm._e()
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cd3e5fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cd3e5fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/titleHead/titleHead.vue
// module id = null
// module chunks = 